import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetPrefixesByEnterpriseIdMessages } from './messages';

export function getGetPrefixesByEnterpriseIdCacheKey(
  enterpriseId: number | null | undefined,
) {
  return `/api/EnterprisePrefix/${enterpriseId}`;
}

export interface useGetPrefixesByEnterpriseIdOptions {
  shouldFetch?: boolean;
}

export function useGetPrefixesByEnterpriseId(
  enterpriseId: number | null | undefined,
  options?: useGetPrefixesByEnterpriseIdOptions,
) {
  const mergedOptions: useGetPrefixesByEnterpriseIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { enterprisePrefixApi } = usePrivate();

  const results = useSWR(
    enterprisePrefixApi && mergedOptions.shouldFetch
      ? getGetPrefixesByEnterpriseIdCacheKey(enterpriseId)
      : null,
    () => enterprisePrefixApi?.apiEnterprisePrefixGet(enterpriseId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetPrefixesByEnterpriseIdMessages[
            'useGetPrefixesByEnterpriseId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetPrefixesByEnterpriseId> error fetching prefixes.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !enterprisePrefixApi;

  return { ...results, isLoadingOrValidating };
}
